<template>
  <div>
    <b-row>
      <b-col />
      <b-col>
        <b-img src="../assets/logo.png" alt="Hoops Yard" height="180"></b-img>
      </b-col>
      <b-col class="d-flex justify-content-end">
        <ul class="mt-2 list-unstyled">
          <li> <strong>Whatsapp:</strong><a href="https://wa.me/+50763084298" target="_blank" title="Hoopsyard en Whatsapp">+50763084298</a></li>
          <li><strong>Instagram:</strong> <a href="https://www.instagram.com/hoopsyard/" target="_blank" title="Hoopsyard en Instagram">@hoopsyard</a></li>
        </ul>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-img src="../assets/courts.jpg" fluid alt="Hoops Yard"></b-img>
      </b-col>
      <b-col>
        <p><strong>Hoops Yard is a unique basketball facility providing a fun and supportive environment for all to enjoy the game of basketball.</strong></p>
        <p> Located in the city of Panamá, Hoops Yard has three&nbsp;basketball courts and a gym for your physical training. Visitors can also enjoy the smoothie bar or the food truck corner. </p>
        <p> Three&nbsp;basketball academies with around 200 youngsters have choosen our venue for their practices. We also host tournaments, international events, private skills training and set up regular pickup game nights. </p>
      </b-col>
      <b-col class="es">
        <p><strong>Hoops Yard es un centro deportivo único en Panamá, donde sus visitantes podrán jugar Baloncesto y disfrutar de unas instalaciones de alto nivel.</strong></p>
        <p> Ubicado en la cuidad de Panamá, Hoops Yard cuenta con tres&nbsp;canchas de baloncesto y un gimnasio para el entrenamiento físico de nuestros atletas y visitantes. Contamos con un smoothie bar y un área de food-truck para que nuestros visitantes puedan disfrutar de una rica comida o batido. </p>
        <p> Tres&nbsp;academias con aproximadamente 200 jóvenes han elegido Hoops Yard como su sede de entrenamiento. Organizamos ligas, torneos, eventos deportivos nacionales e internacionales, birrias nocturnas y entrenamientos personalizados. </p>
      </b-col>
      <div class="w-100 pt-3"></div>
      <b-col>
        <p><strong>Hoops Yard's 1800&nbsp;sq.&nbsp;meters is an excellent space for a highly-visible advertising opportunity for your business.</strong><br>Our advertising partner options include combinations of the following: </p><p><strong>BANNERS</strong> – highly visible banners that hang year-round on Hoops Yard's courts sides. Multiple banner size options are available but space is limited so DO NOT WAIT to claim your spot! </p><p><strong>TOURNAMENT &amp; EVENT SPONSORSHIP</strong> – We are always looking for sponsors for rhe tournament and events we host, branding/titles, signage, player's jerseys, etc. </p><p><strong>Feel free to contact us for a tour of Hoops Yard or if you need any further information.</strong></p>
      </b-col>
      <b-col class="es">
        <p><strong>Hoops Yard cuenta con un acogedor espacio de 1800&nbsp;metros&nbsp;cuadrados lo cuál es una gran oportunidad de publicidad para tu negocio, altamente visible.</strong><br>Nuestro socio publicitario incluye las siguientes opciones: </p><p><strong>BANNERS</strong> – Banners con gran visibilidad que cuelgan a los costados de las canchas todo el año. Varias opciones de tamaños, espacios limitados. NO ESPERES para buscar el tuyo !! </p><p><strong>PATROCINIOS DE TORNEOS Y EVENTOS</strong> – Hoops Yard siempre está en búsqueda de patrocinadores para torneos y eventos, marcas/títulos, señalizaciones, camisetas de jugadores, etc. </p><p><strong>No dudes en contactarnos si necesitas más información.</strong></p>
      </b-col>
      <b-col>
        <p><b-img src="../assets/team-fem.jpg" fluid alt="Hoops Yard"></b-img></p>
        <p><b-img src="../assets/team-masc.jpg" fluid alt="Hoops Yard"></b-img></p>
        <p><b-img src="../assets/map.png" fluid alt="Hoops Yard"></b-img></p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
}
</script>
<style>
.es { color: #13317b; }
</style>
